// src/js/components/fam-course-card.js

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-course-card]").forEach((wrap) => {
    const card = wrap.querySelector(".js-course-card");
    if (!card) return;

    const titleEl = card.querySelector(".js-course-card-title");
    const imgEl = card.querySelector(".js-course-card-img");
    const textEl = card.querySelector(".js-course-card-text");
    const pdfBtn = card.querySelector(".js-course-card-pdf");

    // Recoger los datos definidos en el wrapper HTML
    const title = wrap.dataset.courseTitle || "";
    const text = wrap.dataset.courseText || "";
    // El PDF se obtiene preferiblemente de una etiqueta <a> oculta para que Parcel pueda empaquetarlo
    const pdfAnchor = wrap.querySelector("a.js-course-pdf-asset");
    const pdfLink = pdfAnchor ? pdfAnchor.getAttribute("href") : (wrap.dataset.coursePdf || "").trim();
    // Obtener la imagen procesada por Parcel o de data attribute
    const asset = wrap.querySelector("img.js-course-asset");
    const src = asset ? asset.getAttribute("src") : wrap.dataset.courseImg || "";

    // Poblar datos con variables
    if (titleEl) titleEl.innerHTML = title;
    if (textEl) textEl.innerHTML = text;
    // Asignación con src y alt
    if (imgEl && src) {
      imgEl.src = src;
      // limpiamos tags HTML para usarlo libremente en el texto alt
      imgEl.alt = title.replace(/<[^>]+>/g, '') || "Curso de Fundación";
    }

    // Tratamiento del href al PDF del Dossier
    if (pdfBtn) {
      if (pdfLink && pdfLink !== "#") {
        pdfBtn.href = pdfLink;
      } else {
        // Ocultar botón si no hay PDF
        pdfBtn.style.display = "none";
      }
    }
  });
});
